<template>
  <b-modal
    id="share-link-modal"
    title="Share a link"
    size="lg"
    hide-footer
  >
    <b-form-group>
      <b-input-group>
        <b-form-input
          ref="share"
          :value="shareLink"
        />
        <b-input-group-append>
          <b-button
            id="copy-to-clipboard"
            size="sm"
            title="Click to copy"
            variant="secondary"
            @click="copyToClipboard"
          >
            <i
              class="fa fa-clipboard"
              aria-hidden="true"
            />
          </b-button>

          <b-tooltip
            ref="tooltip"
            target="copy-to-clipboard"
            triggers="none"
          >
            Copied
          </b-tooltip>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
  </b-modal>
</template>

<script>
export default {
  name: 'ShareLinkModal',
  
  props: {
    shareLink: {
      type: String,
      default: ''
    }
  },
  
  methods: {
    copyToClipboard() {
      this.$refs.share.focus()
      this.$refs.share.setSelectionRange(0, this.shareLink.length)
      const success = document.execCommand('copy')
      if (success) {
        this.$refs.tooltip.$emit('open')
      }
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
